import type { FC, ReactNode } from "react";

export const PartnerSection: FC<{
    title: string;
    children: ReactNode;
    headingLevel: 1 | 2;
}> = ({ title, children, headingLevel }) => {
    return (
        <div
            className="border-b border-gray-300 p-2 [&_p]:leading-8 [&_p]:text-md [&_p]:text-gray-700"
        >
            {
                headingLevel === 1 ?
                    <h1 className="mt-0 text-4xl">{title}</h1> :
                    <h2 className="text-2xl">{title}</h2>
            }
            {children}
        </div>
    );
};
